import Cookies from 'js-cookie'

const confidentialDoc = {

	ui: {},

	originalHref: '',

	hasReadMandatory: false,

	init: function() {
		this.bindUI();
		this.bindEvents();
	},

	bindUI: function() {
		this.ui.$document = $(document);

		this.ui.$confDoc = $(".js-confidential-document");
		this.ui.$confDoc_popin = $(".js-confidential-document-popin");

		this.ui.$confDoc_close = $(".js-confidential-document-popin-close");
		this.ui.$confDoc_content = $('.js-confidential-document-popin-content');

		this.ui.$confDoc_mandatoryReading = $('.js-confidential-document-popin-mandatoryReading');
		this.ui.$confDoc_mandatoryReading_mobile = $('.js-confidential-document-popin-mandatoryReading-mobile');

		this.ui.$confDoc_accept = $('.js-confidential-document-popin-accept');
		this.ui.$confDoc_checkbox = $('.js-confidential-document-popin-checkbox');
		this.ui.$confDoc_checkbox_error = $('.js-confidential-document-popin-checkbox-error');
	},

	bindEvents: function() {
		this.ui.$confDoc.on('mousedown', this.popinOpen.bind(this));

		this.ui.$confDoc_close.on('click', this.popinClose.bind(this));
		this.ui.$confDoc_popin.on('click', this.popinClose.bind(this));
		this.ui.$confDoc_content.on('click', this.popinContentClick.bind(this));

		this.ui.$confDoc_accept.on('click', this.popinAccept.bind(this));

		this.ui.$confDoc_checkbox.on('change', this.toggleAcceptButton.bind(this));
		this.ui.$confDoc_mandatoryReading.on('scroll', this.mandatoryReading.bind(this));
		this.ui.$confDoc_mandatoryReading_mobile.on('scroll', this.mandatoryReading.bind(this));
	},

	popinContentClick: function(e) {
		e.stopPropagation();
	},

	popinOpen: function(e) {
		if (Cookies.get('confidential-document') === 'accepted') {
			return false;
		}

		e.preventDefault();

		// Only allow left click
		if (e.which !== 1) {
			return false;
		}

		let $this = $(e.currentTarget);
		let $target = $('#' + $this.attr('data-popin-target'));
		this.originalHref = $this.attr('href');

		if (!$target.hasClass('is-open')){
			$target.fadeIn(200).addClass('is-open');
			$('html, body').addClass('disable-scroll');
		}
	},

    popinClose: function(e) {
		let $this = $(e.currentTarget);
		let $target = $this.closest('.js-confidential-document-popin');

		$target.fadeOut(200).removeClass('is-open');
		$('html, body').removeClass('disable-scroll');
    },

	popinAccept: function(e) {
		let $this = $(e.currentTarget);
		let $target = $this.closest('.js-confidential-document-popin');
		if (this.ui.$confDoc_checkbox.prop('checked') === false) {
			this.ui.$confDoc_checkbox_error.show();
			return false;
		}
		this.ui.$confDoc_checkbox_error.hide();

		Cookies.set('confidential-document', 'accepted', { expires: 1 });

		$target.fadeOut(200).removeClass('is-open');
		$('html, body').removeClass('disable-scroll');

		// Open the document the user clicked on
		window.open(this.originalHref, '_blank').focus();
    },

	mandatoryReading: function(e) {
		const {scrollHeight, scrollTop, clientHeight} = e.target;

		if (Math.abs(scrollHeight - clientHeight - scrollTop) <= 3) {
			this.hasReadMandatory = true;
			this.toggleAcceptButton();
		}
    },

	toggleAcceptButton: function() {
		if (this.ui.$confDoc_checkbox.prop('checked') === true && this.hasReadMandatory) {
			this.ui.$confDoc_accept.prop('disabled', false);
		} else {
			this.ui.$confDoc_accept.prop('disabled', true);
		}
    }

};

module.exports = confidentialDoc;
